import { TField } from './isField';
import { TFieldInput } from './isFieldInput';

export function getFieldProductiveArea(
	field: TField | TFieldInput
): number | string {
	const { productiveArea } = field;
	return productiveArea || '-';
}
